import api from "../api/axios";

export const getTotalSalesByDay = async (today) => {
  console.log("/orders/count/" + today + "/" + today);
  const val = api.get("/orders/count/" + today + "/" + today);
  return val;
};
